import React,{useState} from 'react';
import { Container,Col, Row ,Button} from 'react-bootstrap';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import Iframe from 'react-iframe';
import * as contactusApi from "../../api/contactUsApi"
import { useSignalAbort } from '../../api/useSignalAbort';
import { ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Contactimg() {
  const abortConstants = useSignalAbort()
  // const [isSaving, setIsSaving] = useState(false)
  const [ContactData, setContactData] = useState({Name:"",Email:"", Phone:"" , Country:"", Message:"", CompanyName:""})
  

  const imageStyle = {
    objectFit: 'cover',
    width: '100%', // Adjusted to make the image responsive
    maxHeight: '100vh', // Added to limit the image height on small screens
    filter: 'opacity(1.8) brightness(1)',
  };

  const containerStyle = {
    marginBottom: '10px',
    marginTop: '10px',
    position: 'relative',
    maxWidth: '100%',
    overflow: 'hidden', // Added to hide overflowing content
  };

  const contentContainerStyle = {
    position: 'absolute',
    top: '45%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    color: 'white',
  };
  

  const captionStyle = {
    textAlign: "center",
    padding: "2px",
    marginBottom: "10px",
    boxShadow: "0 4px 10px 0 rgba(0, 0, 0, 0.2)",
    borderRadius: "10px",
    border: "none",
    backgroundColor: "#F7F9FF",
  };
  const captionTextStyleP = {
    fontSize: '1.1rem', 
    width:'100%' ,
    textAlign:'center',
    lineHeight: "2",
    fontWeight: 700
  }
  const mapUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d323.52546385469145!2d55.68034456271263!3d25.277439101366344!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ef59333cdc4230d%3A0x619b40557215b586!2sShams%20Business%20Center!5e0!3m2!1sen!2sin!4v1707377425728!5m2!1sen!2sin"; 

  const DropUsMessage = async (data, abortToken) => {
    try {
      const result = await contactusApi.DropUsMessage(data, abortToken);
      console.log(result);
      // alert(result.data.message)
      toast.success( result.data.message,{
        autoClose: 5000, // Close the toast after 5 seconds
    });
      // Handle the result, maybe update state or perform other actions
    } catch (error) {
      console.error(error);
      // Handle the error, maybe update state or show an error message
    }
  };
  

//form submission
const handleSubmit = (e) => {
  e.preventDefault();
  // setIsSaving(true);

  let newData = {
    Name: ContactData.Name,
    Email: ContactData.Email,
    Phone: ContactData.Phone,
    Country: ContactData.Country,
    Message: ContactData.Message,
    CompanyName: ContactData.CompanyName
  };

  console.log(newData);

  // Pass newData as an argument to DropUsMessage
  DropUsMessage(newData, abortConstants.controllerConfig);
};

const handleChange = (e) => {
  setContactData({ ...ContactData, [e.target.name]: e.target.value })
}
  return (
    <Container fluid style={{ margin: '-18px 0 0 0', padding: 0, position: 'relative' }}>
    {/* Banner start */}
      <div style={containerStyle}>
        <img
          src={process.env.PUBLIC_URL + '/assets/images/ContactPage.png'}
          className="d-block w-100 img-fluid" // Added img-fluid for responsiveness
          alt=""
          style={imageStyle}
        />
        <div style={contentContainerStyle}>
         <h3 className="text-lg captionTextStyle" > Get In Touch </h3>
        </div>
      </div>
      {/* Banner end */}

      <Container className="d-flex align-items-center justify-content-center" style={{ marginTop: '30px', marginBottom:'50px' }}>
          <h1 className="text-lg" style={captionTextStyleP}>
          We're at your service to answer any questions and explore how we can support your needs.          </h1>
        </Container>

{/* Map and form start */}
      <Container style={{ padding: "2px", marginTop: "50px" }}>
        <Row className="justify-content-center">
          <Col xs={12} md={12} lg={6} className="mb-4">
          <div className="card h-80" style={captionStyle}>
              <div className="card-body"> 
              <Iframe url={mapUrl}
            width="100%"
            height="718px"
            frameBorder="0"
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
              </div>
          </div>
          </Col>


          <Col xs={12} md={12} lg={6} sm={12} className="mb-4" >
          <div className="card h-80" style={captionStyle}>
              <div className="card-body">
                <div className="d-block ">

          {/* heading */}
            <div className="ms-3 mt-3 d-flex justify-content-center align-items-center">
              <h3 style={{ color: "#2855A1", margin: "0", fontSize:"semibold 24" }}>Drop Us </h3> &nbsp;&nbsp; 
              <h3 style={{ color: "black", margin: "0", fontSize:"semibold 24" }}>A Message</h3>
            </div>
          {/* heading end */}

          {/* sub heading */}
            <div className="ms-1 mt-5 mb-5 d-flex justify-content-center align-items-center">
               <h6 style={{ color: "black",  fontSize:"semibold 14" }}>Get in touch with us, and one of our consultants will get back to you</h6>
            </div>
          {/* sub heading end */}

                 {/* Form fields */}
                 <Form 
                 onSubmit={handleSubmit}>
                    {/* Name */}
                    <FloatingLabel className="mt-3 ms-5 me-5" controlId="floatingTextarea" label="Name" style={{ color: "#8A8A8A", fontSize: "semibold 14" }}>
                      <Form.Control type="text" name='Name' required style={{ boxShadow: "2px 4px 4px rgba(0, 0, 0, 0.2)" ,border:'none'}} value={ContactData.Name} onChange={handleChange}/>
                    </FloatingLabel>

                    {/* Email */}
                    <FloatingLabel  className="mt-3 ms-5 me-5" controlId="floatingInputGrid" label="Email" style={{ color: "#8A8A8A", fontSize: "semibold 14" }}>
                      <Form.Control type="email" name='Email' required style={{ boxShadow: "2px 4px 4px rgba(0, 0, 0, 0.2)",border:'none' }} value={ContactData.Email} onChange={handleChange}/>
                    </FloatingLabel>

                    {/* Phone number */}
                    <FloatingLabel  className="mt-3 ms-5 me-5" controlId="floatingTextarea" label="Phone number" style={{ color: "#8A8A8A", fontSize: "semibold 14" }}>
                      <Form.Control type="tel" name='Phone' required style={{ boxShadow: "2px 4px 4px rgba(0, 0, 0, 0.2)",border:'none' }} value={ContactData.Phone} onChange={handleChange}/>
                    </FloatingLabel>

                    {/* Country */}
                    <FloatingLabel  className="mt-3 ms-5 me-5" controlId="floatingTextarea" label="Country" style={{ color: "#8A8A8A", fontSize: "semibold 14" }}>
                      <Form.Control type="text" name='Country' required style={{ boxShadow: "2px 4px 4px rgba(0, 0, 0, 0.2)",border:'none' }} value={ContactData.Country} onChange={handleChange}/>
                    </FloatingLabel>

                    {/* Company Name */}
                    <FloatingLabel  className="mt-3 ms-5 me-5" controlId="floatingTextarea" label="Company Name" style={{ color: "#8A8A8A", fontSize: "semibold 14" }} value={ContactData.CompanyName} onChange={handleChange}>
                      <Form.Control type="text" name='CompanyName' required style={{ boxShadow: "2px 4px 4px rgba(0, 0, 0, 0.2)",border:'none' }}/>
                    </FloatingLabel>

                    {/* Message */}
                    <FloatingLabel  className="mt-3 ms-5 me-5" controlId="floatingTextarea" label="Message" style={{ color: "#8A8A8A", fontSize: "semibold 14" }}>
                      <Form.Control as="textarea" name='Message' required style={{ height: '150px',boxShadow: "2px 4px 4px rgba(0, 0, 0, 0.2)" ,border:'none' }} value={ContactData.Message} onChange={handleChange}  />
                    </FloatingLabel>

                    {/* Submit button */}
                    <Button  className="mt-4" type='submit' style={{ height: '40px',width: '75%', backgroundColor: "#FFE114", border: "none", color: "black", fontSize: "semibold 14" ,fontWeight:'bold'}}>Send</Button>
                    <ToastContainer />
                  </Form>
                  {/* Form end */}

                </div>
              </div>
            </div>
          </Col>
          </Row>
      </Container>
{/* Map and form end */}



    </Container>
  );
}

export default Contactimg;